export default {
  bot_name: 'Bot',
  closed_tickets: 'Closed Tickets',
  average_attendance_time: 'Average Attendance Time',
  name: 'Tag',
};
